import CreateOrganisationForm from './CreateOrganisationForm'
import enhance from './CreateOrganisationForm.enhancer.js'

export default enhance(CreateOrganisationForm)



// WEBPACK FOOTER //
// ./src/components/organisms/CreateOrganisationForm/index.js